export const images = require.context('./', true, /\.\/.+\.(?!js)[a-z]+$/);
export const imagePath = (name) => images(`./${name}`, true)

logger.debug('images', images.keys(), imagePath)

export default imagePath;
